import React from "react"
import { Card, CardBody, CardTitle, CardText, Col, Row } from "reactstrap"
import connect from "assets/images/dollarconnect.png"
import laugh from "assets/images/laugh.png"
import compete from "assets/images/compete.png"
import { Link, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { toast, Bounce } from "react-toastify"

const styles = {
  gradientBorder: {
    background: "linear-gradient(45deg, #FFDF2B, #126586, #F1803B, #1D3860)",
    borderRadius: "26px",
    padding: "4px",
    animation: "borderAnimation 2s linear infinite",
    backgroundSize: "200% 200%",
    display: "inline-block",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "24px",
    color: "#fff",
  },
}

const keyframes = `
 @keyframes borderAnimation {
  0% {
    background-position: 0% 50%;
  }
  25% {
    background-position: 50% 0%;
  }
  50% {
    background-position: 100% 50%;
  }
  75% {
    background-position: 50% 100%;
  }
  100% {
    background-position: 0% 50%;
  }
}
`

const styleSheet = document.styleSheets[0]
styleSheet.insertRule(keyframes, styleSheet.cssRules.length)
const isMdOrAbove = window.innerWidth >= 768

const CustomCard = ({ color1, color2, image, title, description }) => (
  <Col xs="12" md="6" lg="4" className="mb-4">
    <div style={styles.gradientBorder}>
      <Card
        style={{
          margin: 0,
          ...styles.card,
          background: `linear-gradient(150.63deg, ${color1} -19.14%, ${color2} 77.98%)`,
          height: "480px",
          maxHeight: "480px",
          border: "0px",
        }}
      >
        <CardBody className="d-flex flex-column align-items-center justify-content-center text-center">
          <div className="rounded-4 d-flex align-items-center justify-content-center ff-proxima">
            <img
              src={image}
              alt={title}
              width={160}
              height={160}
              className="ff-proxima"
            />
          </div>
          <p className="ff-cooper text-white fw-normal font-size-48 pt-3 m-0">
            {title}
          </p>
          <CardText
            className="ff-proxima text-center fw-normal font-size-24 d-flex justify-content-center align-items-center pt-2"
            style={{ lineHeight: "1.2" }}
          >
            {description}
          </CardText>
        </CardBody>
      </Card>
    </div>
  </Col>
)

const CardContainer = () => {
  const { isAuth } = useSelector(state => state.auth)
  const navigate = useNavigate()

  const handleJoinClick = () => {
    if (isAuth) {
      navigate("/dashboard")
    } else {
      toast.error("Please sign in to continue", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      })
      navigate("/login")
    }
  }

  const cardData = [
    {
      color1: "#AFDBC3",
      color2: "#3B7555",
      image: compete,
      title: "CONNECT",
      description:
        "Team up with friends and family to show us your jokes and connect with other dad joke enthusiasts in our community.",
    },
    {
      color1: "#126586",
      color2: "#1D3860",
      image: laugh,
      title: "LAUGH",
      description:
        "Whether you’re having fun making jokes or finding new ones that make you smile, you’ll find plenty of reason to laugh at the Dockies.",
    },
    {
      color1: "#FFDF2B",
      color2: "#F1803B",
      image: connect,
      title: "COMPETE",
      description:
        "Compete in the Dockies monthly joke competitions to win awesome prizes. Plus all winners are featured on Dock Tok social media @loganlisle",
    },
  ]

  return (
    <section id="feature" className="py-4 px-2 px-lg-3 bg-soft-mint-gradien">
      <div className="px-2 px-lg-5 py-5">
        <p className="text-uppercase fw-normal ff-cooper font-size-56 text-center pb-2 black-text-color">
          Join The Dockies to:
        </p>
        <Row>
          {cardData.map((card, index) => (
            <CustomCard
              key={index}
              color1={card.color1}
              color2={card.color2}
              image={card.image}
              title={card.title}
              description={card.description}
            />
          ))}
        </Row>
        <div className="text-center pt-3">
          {!isAuth && (
            <button
              onClick={handleJoinClick}
              className="btn btn-primary-yellow ff-proxima font-size-14 font-weight-500 text-black bg-yellow text-uppercase text-center pt-3"
            >
              Join Our Community
            </button>
          )}
        </div>
      </div>
    </section>
  )
}

export default CardContainer
